import { render, staticRenderFns } from "./PermissionModalSidebar.vue?vue&type=template&id=52328a5c&scoped=true&lang=pug"
import script from "./PermissionModalSidebar.vue?vue&type=script&lang=js"
export * from "./PermissionModalSidebar.vue?vue&type=script&lang=js"
import style0 from "./PermissionModalSidebar.vue?vue&type=style&index=0&id=52328a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52328a5c",
  null
  
)

export default component.exports